// ModelAttribute.ts

export default class ModelAttribute {

    id                          : Number;
    code                        : String;
    name                        : String;
    model_name                  : String;
    value                       : String;
    instance_id                 : Number;

    constructor(dict = null)
    {
        if (dict !== null)
        {
            this.id                  = dict["id"];
            this.code                = dict["code"];
            this.name                = dict["name"];
            this.model_name          = dict["model_name"];
            this.value               = dict["value"];
            this.instance_id         = dict["instance_id"];
        }
    }


  }